if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      // FRAQUANE - garde l'ID de variante et la quantite strictement lies a CE formulaire.
      // Cela evite qu'un Quick View reutilise par erreur la quantite d'une autre fiche presente dans le DOM.
      const variantInput = this.form.querySelector('[name="id"]');
      if (!variantInput || !variantInput.value) {
        this.handleErrorMessage('Variant unavailable');
        this.submitButton.removeAttribute('aria-disabled');
        this.submitButton.classList.remove('loading');
        this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        return;
      }
      formData.set('id', variantInput.value);

      const formId = this.form.getAttribute('id');
      const productScope = this.closest('product-info, quick-add-modal, .product, .product__info-container, .product__info-wrapper');
      const quantityInput =
        this.form.querySelector('input[name="quantity"]') ||
        (formId ? document.querySelector(`input[name="quantity"][form="${CSS.escape(formId)}"]`) : null) ||
        productScope?.querySelector('input[name="quantity"]');

      if (quantityInput && quantityInput.value) {
        const min = Number(quantityInput.min || 1);
        const max = quantityInput.max === '' ? Infinity : Number(quantityInput.max);
        let quantity = Number(quantityInput.value);

        if (!Number.isFinite(quantity) || quantity < min) quantity = min;
        if (Number.isFinite(max) && quantity > max) quantity = max;

        quantityInput.value = String(quantity);
        formData.set('quantity', String(quantity));
      }

      if (this.cart) {
  formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
  formData.append('sections_url', window.location.pathname);
  this.cart.setActiveElement(document.activeElement);
}
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}